export default __webpack_public_path__ + "static/media/slide2.056fe5d8.jpg";